const moment = require('moment');

const utils = require('..').utils;

moment.defineLocale('en-US', {
  parentLocale: 'en',
  weekends: [0, 6],
  holidays: [
    utils.adjustIfWELikeInUSA('01-01'), // new year's day
    utils.xxDayOfMonth(3, 1, 1), // Martin Luther King, Jr. Day
    year => year % 4 === 1 ? moment('20-01', 'DD-MM').year(year) : moment.invalid(), // Inauguration day
    utils.xxDayOfMonth(3, 1, 2), // George Washington’s Birthday
    utils.lastDayOfMonth(1, 5), // Memorial day
    utils.adjustIfWELikeInUSA('04-07'), // Independence day
    utils.xxDayOfMonth(1, 1, 9), // Labor day
    utils.xxDayOfMonth(2, 1, 10), // Columbus day
    utils.adjustIfWELikeInUSA('11-11'), // Veterans day
    utils.xxDayOfMonth(4, 4, 11), // Thanksgiving day
    '25-12',
  ],
});
